/**
 * OrbDocReferenceOperatorsValidateSLOrbDocReferenceOperatorsValidateSLPage
 *
 * Page component for OrbDocReferenceOperatorsValidateSLOrbDocReferenceOperatorsValidateSLPage
 * Path: /sl/docs/reference/operators/validate
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocReferenceOperatorsValidateSLDocScreenView as __OrbDocReferenceOperatorsValidateSLDocScreenView } from '@/components/traits/OrbDocReferenceOperatorsValidateSLDocScreenView';
import { OrbDocReferenceOperatorsValidateSLDocAnalyticsView as __OrbDocReferenceOperatorsValidateSLDocAnalyticsView } from '@/components/traits/OrbDocReferenceOperatorsValidateSLDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocReferenceOperatorsValidateSLOrbDocReferenceOperatorsValidateSLPageProps {
  // Add any page-level props here
}

export function OrbDocReferenceOperatorsValidateSLOrbDocReferenceOperatorsValidateSLPage(_props: OrbDocReferenceOperatorsValidateSLOrbDocReferenceOperatorsValidateSLPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"Preverjanje","description":"Vsak operator, ki ga program .lolo lahko pokliče, iz kanoničnega registra, ki ga prevajalnik vgradi.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/reference/operators/validate"},{"locale":"ar","path":"/ar/docs/reference/operators/validate"},{"locale":"sl","path":"/sl/docs/reference/operators/validate"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocReferenceOperatorsValidateSLDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocReferenceOperatorsValidateSLDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocReferenceOperatorsValidateSLOrbDocReferenceOperatorsValidateSLPage;
